import { createFileRoute } from '@tanstack/react-router'

import WriteUserAdminPage from '@/components/pages/backoffice/_user/_admin/containers/WriteUserAdminPage'

export const Route = createFileRoute('/_backoffice/user/admin/$adminId/edit')({
  component: AdminEditPage
})

function AdminEditPage() {
  const { adminId } = Route.useParams()

  return <WriteUserAdminPage type="edit" userId={adminId} />
}
